"use client"
import styled from "@emotion/styled"
import { Button } from "@mui/material"
import dynamic from 'next/dynamic'
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper"
import animationData from 'public/animation/Charge_micro.json'
import { useEffect, useState } from "react"

import { TrackMapSource, trackEventByNameAndCategory } from "reusable/ChargeGTM"
import { NewText, TitleWithLine, extractProperty } from "ui"
import { sharedColors } from "ui/theme/colors"
import { getNonUmbracoURL } from "utils/utils"

// Dynamically import ReactPlayer to ensure it's client-only
const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false })

// Dynamically import Lottie to ensure it's client-only
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

// Define styled components
const VideoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 60px;
   padding-bottom: 60px;
    ${(props) => props.theme.breakpoints.up("md")} {
    padding-bottom: 60px;
  }
`
const StyledWrapper = styled.div<{ backgroundColor: string }>`
 background-color: ${(props) => props.backgroundColor};
`
const StyledVideoText = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`
const StyledButton = styled(Button)`
  width: 216px;
  height: 32px;
  padding: 8px 20px 8px 20px;
  border-radius: 24px;
  opacity: 0px;
  background-color: ${sharedColors.blue};
  gap: 12px;

  ${(props) => props.theme.breakpoints.up("md")} {
    height: 45px;
    width: 220px;
    border-radius: 40px;
  }
`
const StyledVideoPlayer = styled.div`
  width: 100%;
  height: 589px;
  gap: 0px;
  border: 1px solid #153E691A;
  border-radius: 12px 0px 0px 0px;
  border: 1px 0px 0px 0px;
  opacity: 0px;
  box-shadow: 0px 0px 14px 0px #00000024;

  ${(props) => props.theme.breakpoints.down("md")} {
    height: 500px;
  }
`
export enum VideoBlockChargePropsBGColor {
  WHITE = "white",
  LIGHT_GRAY = "rgba(21, 62, 105, 0.1)"
}
type VideoBlockChargeProps = {
  data: any,
  backgroundColor?: VideoBlockChargePropsBGColor
}

function VideoBlockCharge({ data, backgroundColor = VideoBlockChargePropsBGColor.WHITE }: VideoBlockChargeProps) {
  const title = extractProperty(data, "title")
  const subTitle = extractProperty(data, "subTitle")
  const text = extractProperty(data, "text")
  const videoUrl = extractProperty(data, "videoUrl")
  const buttonArea = extractProperty(data, "button")
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])


  return (
    <StyledWrapper
      backgroundColor={backgroundColor}
    >
      <ContainerWrapper>

        <VideoWrapper>
          <TitleWithLine
            titleFontSize={34}
            desktopLineHeight="36px"
            desktopFontWeight={500}
            mobileTitleFontSize={24}
            mobileLineHeight="28px"
            component="h2"
            titleColor="black"
            title={title}
            lineMarginTop={10}
            noMobileMargin
          />
          <NewText
            desktopFontSize={18}
            desktopLineHeight="20px"
            desktopFontWeight="400"
            mobileFontSize={16}
            mobileLineHeight="18px"
            mobileFontWeight="400"
            component="p"
          >
            {subTitle}
          </NewText>
          {buttonArea.length > 0 && (
            <StyledButton
              variant="contained"
              href={getNonUmbracoURL(buttonArea[0].url)}
              onClick={() => trackEventByNameAndCategory('open_map', TrackMapSource.BODY)}
            >
              למפת עמדות טעינה
              <Lottie animationData={animationData} loop={true} style={{ marginTop: 5 }} />
            </StyledButton>
          )}
          {text && (
            <StyledVideoText>
              <NewText
                desktopFontSize={18}
                desktopLineHeight="20px"
                desktopFontWeight="400"
                mobileFontSize={16}
                mobileLineHeight="18px"
                mobileFontWeight="400"
                component="p"
              >
                {text}
              </NewText>
            </StyledVideoText>
          )}
          <StyledVideoPlayer>
            {isMounted && (
              <ReactPlayer
                width={"100%"}
                height={"100%"}
                url={videoUrl[0].url}
              />
            )}
          </StyledVideoPlayer>
        </VideoWrapper>
      </ContainerWrapper>
    </StyledWrapper>
  )
}

// // Dynamically import the VideoBlockCharge component
// const VideoBlockCharge = dynamic(() => Promise.resolve(VideoBlockChargeComponent), {
//     ssr: false,
// })

export default VideoBlockCharge
